// Use same-origin for beypointer.com domains to avoid www/apex CORS issues
const getBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname.endsWith('beypointer.com')) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
};

export const BACKEND_URL = getBackendUrl();
